<a
  coreIconButton
  [icon]="isWebView ? 'download' : 'open'"
  [shadow]="true"
  variant="light"
  (click)="saveMedia()">
</a>
